/**
 * InfoCar Grafiche categories — catalog for vehicle entry step 2.
 * Replace/update this export or swap to GET /your-endpoint in the accordion component when ready.
 * categoryCode values are stable identifiers; titles are localized payloads (can mirror Mongo / Excel rows).
 */

export const MOCK_TITLE_CODES = ["OPTION_A", "OPTION_B", "OPTION_C"];

/** Builds placeholder line rows for mock UI (later replaced by InfoCar/API titles). */
export function buildMockTitlesForCategory(categoryCode) {
  const labels = {
    OPTION_A: { it: "A", en: "A", sq: "A" },
    OPTION_B: { it: "B", en: "B", sq: "B" },
    OPTION_C: { it: "C", en: "C", sq: "C" },
  };
  return MOCK_TITLE_CODES.map((code) => ({
    _id: `mock-${categoryCode}__${code}`,
    partCode: code,
    selected: true,
    notes: "",
    title: labels[code],
  }));
}

export const DEFAULT_GRAFICHE_CATEGORIES = [
  {
    categoryCode: "graf_ext_body",
    sortOrder: 1,
    title: {
      it: "Lamierati esterni",
      en: "External body panels",
      sq: "Panele të jashtme",
    },
  },
  {
    categoryCode: "graf_int_body",
    sortOrder: 2,
    title: {
      it: "Lamierati interni",
      en: "Internal body panels",
      sq: "Panele të brendshme",
    },
  },
  {
    categoryCode: "graf_lighting",
    sortOrder: 3,
    title: {
      it: "Fanaleria",
      en: "Lighting",
      sq: "Ndriçimi",
    },
  },
  {
    categoryCode: "graf_upholstery",
    sortOrder: 4,
    title: {
      it: "Selleria",
      en: "Upholstery",
      sq: "Tapiceria",
    },
  },
  {
    categoryCode: "graf_engine_gear_mounts",
    sortOrder: 5,
    title: {
      it: "Motore e cambio con supporti",
      en: "Engine and gearbox with mounts",
      sq: "Motori dhe çangjio me mbështetëse",
    },
  },
  {
    categoryCode: "graf_bumper_front",
    sortOrder: 6,
    title: {
      it: "Paraurti anteriore",
      en: "Front bumper",
      sq: "Parakolpe i përparmë",
    },
  },
  {
    categoryCode: "graf_bumper_rear",
    sortOrder: 7,
    title: {
      it: "Paraurti posteriore",
      en: "Rear bumper",
      sq: "Parakolpe i pasëm",
    },
  },
  {
    categoryCode: "graf_steering",
    sortOrder: 8,
    title: {
      it: "Sterzo",
      en: "Steering",
      sq: "Drejtimi",
    },
  },
  {
    categoryCode: "graf_suspension",
    sortOrder: 9,
    title: {
      it: "Sospensioni",
      en: "Suspension",
      sq: "Pezullimi",
    },
  },
  {
    categoryCode: "graf_glass",
    sortOrder: 10,
    title: {
      it: "Cristalli",
      en: "Glass",
      sq: "Xhamat",
    },
  },
  {
    categoryCode: "graf_fuel_exhaust",
    sortOrder: 11,
    title: {
      it: "Alimentazione e scarico",
      en: "Fuel and exhaust system",
      sq: "Ushqyesi dhe sistem shkarkimi",
    },
  },
  {
    categoryCode: "graf_trans_drive",
    sortOrder: 12,
    title: {
      it: "Cambio e trasmissioni",
      en: "Gearbox and driveline",
      sq: "Çangjio dhe transmetimi",
    },
  },
  {
    categoryCode: "graf_brakes",
    sortOrder: 13,
    title: {
      it: "Impianto frenante",
      en: "Braking system",
      sq: "Sistemi i frenimit",
    },
  },
  {
    categoryCode: "graf_interior_trim",
    sortOrder: 14,
    title: {
      it: "Rivestimenti interni e parti interne",
      en: "Interior trim and fittings",
      sq: "Veshje të brendshme dhe pjesa të brendshme",
    },
  },
  {
    categoryCode: "graf_safety",
    sortOrder: 15,
    title: {
      it: "Dispositivi di sicurezza",
      en: "Safety devices",
      sq: "Pajisjet e sigurisë",
    },
  },
  {
    categoryCode: "graf_climate",
    sortOrder: 16,
    title: {
      it: "Climatizzazione",
      en: "Climate control",
      sq: "Klimatizimi",
    },
  },
];
